export const state = {
  data: [],
  isVisibleFirstPanel: false,
  isVisibleSecondPanel: false,
  activeFirstElement: null,
  adverts: {
    isLoad: false
  },
  animation: {
    firstPanel: {
      show: 0,
      hidden: "-100",
      stagger: 75,
      staggerOpacity: 0,
      staggerSocial: 20
    }
    // secondPanel: {
    //   show: () => {
    //     return window.matchMedia("(max-width: 992px)").matches ? "15vw" : 0
    //   },
    //   close: () => {
    //     window.matchMedia("(max-width: 992px)").matches ? "100vw" : 0
    //   }
    // }
  }
}
